// import _ from "lodash";
import { makeAutoObservable, observable, runInAction } from 'mobx';
import GlobalNotification from '../../../component/common/snackbar';
import { HeadCell } from '../../../component/table/table.component';
import i18n from '../../../i18n';
import { Restaurant } from '../../../models';
import apiManage from '../../../request';
import { groupUnitData } from '../group-unit';
import { IRestaurantInfoState } from './restaurant-info-state';
import _ from 'lodash';
import { ConditionType } from '../../../component/form/search-key-input.component';


export class RestaurantManageState implements IRestaurantManageState {

    constructor() {
        makeAutoObservable(this);
    }

    // *********************
    // Attributes
    // *********************

    // 集团stringId
    belongedGroup: string = '';
    // 列表数据
    list: Restaurant[] = [];
    // 每页n行
    paginationPerPage: number = 20;
    // 总数
    allCount: number = 0;
    // 当前页
    currentPage: number = 1;
    // 列表过滤
    extraParams: Restaurant = {};
    // 列表加载
    isTableLoading: boolean = false;
    // 确认弹窗
    confirmDialogData: {
        visible: boolean;
        title: string;
        content: string;
        forbidConfirm?: number;
        handleClick?: () => void;
    } = {
            visible: false,
            title: '',
            content: '',
            forbidConfirm: 0
        }
    // 搜索key
    selectValue: string = 'nickname';
    // 业务标签选择的值
    businessSelectValue: string[] = [];
    // 搜索值
    searchValue: string = '';
    // 显示弹窗 - 信息
    isShowRestaurantDialog: boolean = false;
    // 新建方式选择弹窗标识
    isCreateModeDialogOpen: boolean = false;
    // 弹窗组件类型
    dialogComponentType?: IRestaurantInfoState['componentType'];
    // 餐厅 Id
    restaurantId?: string;
    // 餐厅 stringId
    restaurantStringId?: string;
    // 授权方案弹窗
    restaurantAuthDialog: {
        open: boolean;
        onCancel: () => void;
    } = {
            open: false,
            onCancel: () => { }
        }
    // 列表排序
    listSort: {
        sort_key: string;
        sort_value: string;
        sort_control: number;
    } = {
            sort_key: '',
            sort_value: '',
            sort_control: 0
        }
    // 搜索条件
    conditions = observable<ConditionType>([]);



    // *********************
    // Function
    // *********************

    async init() {
        this.belongedGroup = groupUnitData?.belongedGroup;
        if (this.belongedGroup) {
            await this.getRestaurantCondition();
        }
    }

    // 设置搜索条件
    setConditions(val: ConditionType[]) {
        this.conditions.replace(val);
        this.getRestaurantCondition();
    }
    /**
     * 设置排序字段
     */
    handleSort(headCell: HeadCell) {

        let value = '';
        let sortControl = 0;
        switch (headCell.sortStatus) {
            case 0:
                value = '1';
                sortControl = 1;
                break;
            case 1:
                value = '-1';
                sortControl = 2;
                break;
            case 2:
                value = '';
                sortControl = 0;
                break;
            default:
                value = '';
                sortControl = 0;
                break;
        }

        this.listSort = {
            sort_key: sortControl === 0 ? '' : headCell.id,
            sort_value: value,
            sort_control: sortControl
        }
        this.getRestaurantCondition();
    }

    // 获取到餐厅数据
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getRestaurantCondition(page: number = 1, paginationPerPage: number = this.paginationPerPage, extra: Restaurant = this.extraParams) {
        this.loadTable();
        const searchObj = {};
        let sortObj = {};
        this.conditions.forEach((item) => {
            searchObj[item.key] = searchObj[item.key] ? _.concat(searchObj[item.key], item.value) : [item.value];
        })
        if (this.listSort?.sort_value) {
            let key = '';
            switch (this.listSort?.sort_key) {
                case 'city':
                    key = 'city'
                    break;
                case 'nickname':
                    key = 'nickname';
                    break;
                default:
                    key = '';
                    break;
            }
            sortObj = {
                sort_key: key,
                sort_value: this.listSort.sort_value,
            }
        }
        const params = {
            pagination_per_page: 9999,
            pagination_page: page,
            belonged_group: this.belongedGroup,
            business_labels: this.businessSelectValue.length > 0 ? this.businessSelectValue : undefined,
            ...searchObj,
            ...sortObj,
            ...extra
        }
        const result = await apiManage.get_restaurant_condition(params);
        if (!result?.error) {
            const { dbResults } = result[0];
            runInAction(() => {
                this.list = dbResults;
                // this.allCount = _.get(totalCount, '0.count', 0);
                this.currentPage = page - 1;
            })
        } else {
            GlobalNotification.error(i18n.t('restaurant_page_request_text_failed_to_get_a_list_of_restaurants'));
        }
        this.loadedTable();
    }

    // 加载表格开启
    loadTable() {
        this.isTableLoading = true;
    }

    // 加载表格关闭
    loadedTable() {
        this.isTableLoading = false;
    }

    updateConfirmDialogData(data: typeof this.confirmDialogData) {
        this.confirmDialogData = data;
    }

    // 删除餐厅
    async handleDelete(ids: string[]) {
        // this.updateConfirmDialogData({
        //     visible: true,
        //     title: i18n.t('general_text_tips'),
        //     content: i18n.t('general_text_whether_to_delete_the_selection'),
        // })
        const result = await apiManage.delete_restaurant(ids);

        // 删除餐厅成功
        if (!result?.error) {
            GlobalNotification.success(i18n.t('general_message_text_delete_successfully'));
            await this.getRestaurantCondition();
        }
        // 删除餐厅失败
        else {
            GlobalNotification.error(i18n.t('general_message_text_delete_failed'));
        }
        this.updateConfirmDialogData({
            visible: false,
            title: '',
            content: ``,
        })
    }

    handleEdit(restaurantId: string) {
        this.isShowRestaurantDialog = true;
        this.dialogComponentType = 'EDIT';
        this.restaurantId = restaurantId;
    }

    /** 打开餐厅新建方式选择弹窗，避免直接进入手动表单。 */
    openCreateModeDialog() {
        this.isCreateModeDialogOpen = true;
    }

    /** 关闭餐厅新建方式选择弹窗。 */
    closeCreateModeDialog() {
        this.isCreateModeDialogOpen = false;
    }

    /** 选择手动填写后关闭方式选择，并打开原餐厅新增弹窗。 */
    continueManualCreate() {
        this.isCreateModeDialogOpen = false;
        this.showRestaurantDialog(true);
    }

    updateSelectValue(val: string) {
        this.selectValue = val;
        if (val === 'business_labels') {
            // 如果选择业务标签筛选器  清空之前搜索的值
            if (this.searchValue !== '') {
                this.updateSearchValue('')
            }
        } else {
            this.setBusinessEmptyValues([])
        }
    }

    // 设置业务标签空值
    setBusinessEmptyValues(value: string[]) {
        this.businessSelectValue = value;
    }

    /**
     * 设置业务标签的值
     * @param value
     */
    async updateBusinessSelectValues(value: string[]) {
        this.businessSelectValue = value;
        await this.getRestaurantCondition();
    }

    showRestaurantDialog(val: boolean) {
        this.isShowRestaurantDialog = val;
        this.dialogComponentType = 'ADD';
        this.restaurantId = '';
    }

    updateSearchValue(value: string) {
        this.searchValue = value;
    }

    updateRestaurantAuthDialog(open: boolean, restaurantStringId?: string) {
        this.restaurantStringId = restaurantStringId;
        this.restaurantAuthDialog = {
            open,
            onCancel: () => this.updateRestaurantAuthDialog(false)
        }
    }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IRestaurantManageState {

}